export const module = {
  info: {
    name: 'jikatel-rate-manual',
    caption: 'Jikatel Rate Manual'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  sideMenu: {
    caption: 'Jikatel Rate Manual',
    icon: 'el-icon-edit-outline',
    routeName: 'module->jikatel-rate-manual->panel',
  }
}

export default module
